/*
 * @Description: 
 */
/*
 * @Description: 
 */
/*
 * @Description: 
 */ 
/*
 * @Description: 
 */ 
import axios from 'axios'
import Vue from 'vue'

axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.error(error)
})

axios.interceptors.response.use(response => {
  if (response.status === 200) {
    //更新token值
    if(response.headers.access_token){
      localStorage.setItem('access_token', response.headers.access_token)
      localStorage.setItem('refresh_token', response.headers.refresh_token)
    }
    // 需要重新登录
    if(response.data.code==='003'){
      // let code = localStorage.getItem('code')
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('cuser_info')
      // if(code){
        //  location.href='http://www.dlmeasure.com/static/get-weixin-code.html?appid=wxc9d534c9f1a54f4a&scope=snsapi_base&state=STATE&redirect_uri=http%3A%2F%2Fweixin.zjsxss.com%2F%23%2F'
      // }
    }
    return Promise.resolve(response.data)
  } else {
    return Promise.reject(response)
  }
}, e => {
  return Promise.reject(e)
})

let getHeaders = () => {

  let headers = {
      "access-token": localStorage.getItem('access_token'),
      "refresh-token": localStorage.getItem('refresh_token'),
      "token":localStorage.getItem('token')
  };

  return headers;
};

export default {
  post(url, data){
    return axios({
      method: "post",
      baseURL: '',
      url,
      data: data,
      timeout: 30000,
      headers: getHeaders()
    }).then(res => res).catch(e => {
      Vue.prototype.$clear()
      if(e.message.indexOf('timeout')!==-1){
        Vue.prototype.$toast('请求超时')
      } else {
        Vue.prototype.$toast(e.message)
      }
      return Promise.reject(e);
    });
  },
  get(url, params){
    return axios({
        method: "get",
        baseURL: '',
        url,
        params, // get 请求时带的参数
        timeout: 30000
    }).then(res => res).catch(e => {
      Vue.prototype.$clear()
      if(e.message.indexOf('timeout')!==-1){
        Vue.prototype.$toast('请求超时')
      } else {
        Vue.prototype.$toast(e.message)
      }
      return Promise.reject(e);
    });
  },
}
